// extracted by mini-css-extract-plugin
module.exports = {"box":"homeintro_box__194Ca"};